module.exports = __webpack_public_path__ + "static/media/thumbnail.5254f408.png";